import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from "@angular/fire/auth";
import firebase from 'firebase/app'
import { Observable, throwError } from 'rxjs';
import { LoginService } from '../services/login/login.service';
import { User } from 'app/model/user';
import { catchError, map, switchMap } from 'rxjs/operators';
import { promise } from 'protractor';
import { throws } from 'assert';
import { UserService } from '../services/data/user-service';
import { Rol } from 'app/model/rol';
import { blobToBase64 } from '../utils/imageUtils';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private user: User;
  private admin: any;
  userRoles: any;
  username: any;
  password: any;
  isLoggedIn: any;

  /**
   * Constructor
   * @param _firebaseAuth
   * @param router
   */
  constructor(public _firebaseAuth: AngularFireAuth, public router: Router, public loginService: LoginService, private userService: UserService) {
  }

  esAdmin() {
    return this.admin = 1;
  }

  signupUser(email: string, password: string) {
    // your code for signing up the new user
  }

  // Este es el que venia anteriormente, pero no lo entiendo bien, por lo que he creado sigininUser2
  signinUser(username: string, password: string, callback: (isLoggedIn: boolean) => void) {
    this.user = new User();
    this.user.username = username;
    this.user.password = password;
    this.loginService.generateToken(this.user).subscribe({
      next: (data: any) => {

        if (data.token) {
          this.loginService.loginUser(data.token);
          this.loginService.getCurrentUser(data.token).subscribe({
            next: (user: User) => {
              this.userService.getUserProfilePictureById(user.id)
                .pipe(
                  switchMap((blob) => blobToBase64(blob))
                )
                .subscribe((profilePicture) => {
                  user.profilePicture = profilePicture

                  this.loginService.setUser(user)

                  this.isLoggedIn = true

                  callback(this.isLoggedIn)
                })
            }, error(err: any) {

              callback(false);
            }
          })
        }
      }, error(error: any) {

        callback(false)
      }
    })

  }

  signInUser2(username: string, password: string, callback: (isLoggedIn: boolean) => void) {
    this.userService.getUserByUsername(username).pipe(map((data) => data as User))
      .subscribe((data) => {
        if (Array.isArray(data) && data.length > 0) {
          const firstCommunication = data[0];

          this.userRoles = firstCommunication.userRoles;
          this.password = firstCommunication.password;
          this.username = firstCommunication.username;
          // Verificar si las credenciales son correctas
          if (this.username == username && this.password == password) {

            sessionStorage.setItem('user', this.username);

            this.isLoggedIn = true;
          } else {
            console.log('Credenciales incorrectas');
          }
          callback(this.isLoggedIn); // Llamamos al callback con el estado de inicio de sesión
        } else {

          callback(false); // Llamamos al callback con falso porque el usuario no fue encontrado
        }
      },
        (error) => {
          console.error('Error al obtener los datos:', error);
          callback(false); // Llamamos al callback con falso en caso de error
        });
  }

  signinUserFromToken(callback: (isLoggedIn: boolean) => void) {
    const tokenStr = sessionStorage.getItem('token');
    this.loginService.getCurrentUser(tokenStr).subscribe({
      next: (user: User) => {
        this.userService.getUserProfilePictureById(user.id)
          .pipe(
            switchMap((blob) => blobToBase64(blob))
          )
          .subscribe((profilePicture) => {
            user.profilePicture = profilePicture

            this.loginService.setUser(user)

            this.isLoggedIn = true

            callback(this.isLoggedIn)
          })
      }, error(err: any) {
        callback(false);
      }
    })
  }



  logout() {
    /*  this._firebaseAuth.signOut();*/
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
    this.router.navigate(['/pages/login']);
  }

  getUsername(): Observable<string> {
    return this.userService.getUserByUsername(this.username).pipe(
      map((data) => {
        if (Array.isArray(data) && data.length > 0) {
          const firstCommunication = data[0];
          return firstCommunication.username;
        } else {
          throw new Error('No se encontró el nombre de usuario.');
        }
      })
    );
  }

  newPass(email: string) {
    return new Promise<void>((resolve, reject) => {
      this.loginService.getNewPassword(email).subscribe({
        next: (data: any) => {
          if (data) {
            resolve();
          } else {
            reject('Email no encontrado status: ' + data.status);
          }
        },
        error: (err: any) => {
          reject(err);
        },
        complete: () => {
          console.log('complete');
        },
      });
    });
  }

  getUserRoles(): Observable<String[]> {
    const tokenStr = sessionStorage.getItem('token');
    return this.loginService.getCurrentUser(tokenStr).pipe(
      map((data: User) => {
        if (data.userRoles.length > 0) {
          let roles: String[] = [];
          data.userRoles.map(role => roles.push(role.name));
          return roles;
        } else {
          return []; // Retornamos un array vacío si no hay roles
        }
      })
    );
  }

  isAuthenticated() {
    return this.isLoggedIn;
  }
}
